export const ControlAlgorithm = Object.freeze({
  DISABLED: 255,
  SELF_CONSUMPTION: 0,
  ELION: 1,
  ELION_DEV: 2,
  DEFAULT: 1,
});
